module.exports = __webpack_public_path__ + "img/7.6e92c29d.svg";